import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import SlackAccessAuth from '../components/auth/SignInPage/SlackAccess';
import SlackAccessHelpdesk from '../components/auth/SignInPage/SlackAccessHelpdesk';
import SignInForm from '../components/auth/SignInPage/SignInForm';
import SlackAuth from '../components/auth/slackAuth.js';
import SlackJiraAuth from '../components/auth/slackAuthJiraApp';
import SlackStandupAuth from '../components/auth/standupSlackOuath';
import SlackHelpdeskAuth from '../components/auth/helpdeskSlackOauth';
import StripeWrapper from '../components/billing/stripeWrapper';
import GoogleAuth from '../components/auth/googleAuth';
import Appsumo from '../components/Appsumo';
// New Enjo-style auth screens (OTP + cookies). Self-contained module.
import TrooprSignIn from '../components/auth/troopr/TrooprSignIn';
import TrooprSignUp from '../components/auth/troopr/TrooprSignUp';
import EmailVerification from '../components/auth/troopr/EmailVerification';
import TrooprSlackCallback from '../components/auth/troopr/TrooprSlackCallback';

// console.log("signi====>")
const signUpRoutes = () => (
  <div>
    <Switch>
      <Route exact path='/slack_login' component={SlackAccessAuth} />
      <Route
        exact
        path='/slack_helpdesk_login'
        component={SlackAccessHelpdesk}
      />
      {/* New Enjo-style sign-in/up + OTP verification */}
      <Route exact path='/troopr/access' component={TrooprSignIn} />
      <Route exact path='/signup' component={TrooprSignUp} />
      <Route exact path='/verification' component={EmailVerification} />
      <Route exact path='/troopr/slack_callback' component={TrooprSlackCallback} />
      {/* Legacy Slack-first sign-in kept available during transition */}
      <Route exact path='/troopr/legacy_access' component={SignInForm} />
      <Route exact path='/appsumo' component={Appsumo} />
      <Route path='/troopr/googleAuth' component={GoogleAuth} />
      <Route path='/slack_auth' component={SlackAuth} />
      <Route path='/slack_jira_auth' component={SlackJiraAuth} />
      <Route path='/slack_standup' component={SlackStandupAuth} />
      <Route path='/slack_helpdesk' component={SlackHelpdeskAuth} />
      <Route exact path='/troopr_billing/:wId' component={StripeWrapper} />
      <Route path='/*' render={() => <Redirect to='/troopr/access' />} />
    </Switch>
  </div>
);

export default signUpRoutes;
